export default "__VITE_ASSET__CnHBWXmc__"